import type { ReactNode } from 'react'

interface PanelProps {
  children: ReactNode
  className?: string
}

export function Panel({ children, className = '' }: PanelProps) {
  return (
    <div
      className={`bg-surface-card dark:bg-dark-card transition-colors border-[2.5px] border-ink dark:border-dark-border rounded-[14px] shadow-[5px_5px_0_#111111] dark:shadow-[5px_5px_0_#000000] overflow-hidden ${className}`}
    >
      {children}
    </div>
  )
}
